"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isElementOfType = void 0;
var react_1 = require("react");
/*
 * Checks whether `element` is a React element of type `Component` (or one of
 * the passed components, if `Component` is an array of React components).
 */
function isElementOfType(element, Component) {
    if (element == null ||
        !react_1.isValidElement(element) ||
        typeof element.type === 'string') {
        return false;
    }
    var type = element.type;
    var Components = Array.isArray(Component) ? Component : [Component];
    return Components.some(function (AComponent) {
        return typeof type !== 'string' && isComponent(AComponent, type);
    });
}
exports.isElementOfType = isElementOfType;
/*
 * In development, we compare based on the name of the function because
 * React Hot Loader proxies React components in order to make updates. In
 * production we can simply compare the components for equality.
 */
var isComponent = process.env.NODE_ENV === 'development'
    ? hotReloadComponentCheck
    : function (Comp1, Comp2) {
        return Comp1 === Comp2;
    };
function hotReloadComponentCheck(Comp1, Comp2) {
    var Comp1Name = Comp1.name;
    var Comp2Name = Comp2.name;
    var Comp1DisplayName = Comp1.displayName;
    var Comp2DisplayName = Comp2.displayName;
    return (Comp1 === Comp2 ||
        (Boolean(Comp1Name) && Comp1Name === Comp2Name) ||
        (Boolean(Comp1DisplayName) && Comp1DisplayName === Comp2DisplayName));
}
//# sourceMappingURL=isElementOfType.js.map